export default "__VITE_ASSET__N6vNMsI8__"